import React from "react";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { Mascot, StepHeading, ContinueButton, CtaRow, Item, CheckBadge } from "../NOKit";

// "How did you find us" — kept for attribution. Multi-select, optional.
// `value` is what's stored (unchanged); `label` is just what the tile says.
// Friends / School / Other are generated flat icons (gpt-image-2 via
// Replicate, white keyed out) drawn to sit beside the brand logos.
const SOURCES = [
  { icon: "/assets/source-friends.png", label: "Friends", value: "Friend/Family" },
  { icon: "/assets/google.png", label: "Google", value: "Google" },
  { icon: "/assets/tiktok.png", label: "TikTok", value: "TikTok" },
  { icon: "/assets/instagram.png", label: "Instagram", value: "Instagram" },
  { icon: "/assets/linkedin.png", label: "LinkedIn", value: "LinkedIn" },
  { icon: "/assets/source-school.png", label: "School", value: "School" },
  { icon: "/assets/facebook.svg", label: "Facebook", value: "Facebook" },
  { icon: "/assets/source-other.png", label: "Other", value: "Other" },
];

const DiscoverySourceStep = () => {
  const { username, discoverySource, setDiscoverySource, nextStep } = useOnboarding();

  const toggle = (value) => {
    if (discoverySource.includes(value)) setDiscoverySource(discoverySource.filter((s) => s !== value));
    else setDiscoverySource([...discoverySource, value]);
  };

  return (
    <>
      <Mascot clip="panda_jumping" zoom={1.8} />
      <StepHeading
        eyebrow={username ? `So happy you're here, ${username}` : "So happy you're here"}
        title="How did you"
        accent="find us?"
        subtitle="Pick all that apply — it helps more families find Pixley."
      />
      <Item className="ob-sources" role="group" aria-label="Where you found Pixley">
        {SOURCES.map((source) => {
          const selected = discoverySource.includes(source.value);
          const isImage = source.icon.startsWith("/");
          return (
            <button
              key={source.value}
              type="button"
              role="checkbox"
              aria-checked={selected}
              className={`ob-source${selected ? " is-selected" : ""}`}
              onClick={() => toggle(source.value)}
            >
              <span className="ob-source-icon" aria-hidden="true">
                {isImage ? <img src={source.icon} alt="" /> : source.icon}
              </span>
              <span className="ob-source-name">{source.label}</span>
              {selected && <CheckBadge />}
            </button>
          );
        })}
      </Item>
      <CtaRow>
        <ContinueButton onClick={nextStep} />
      </CtaRow>
    </>
  );
};

export default DiscoverySourceStep;
